'use strict';

$(document).ready(function () {
    // category Track: Start
    var $categoryName;
    if ($('.category-heading').length) {
        $categoryName = $('.category-heading').text();
    }
    console.log('categoryName');
    console.log($categoryName);
    if ($categoryName) {
        $('body').trigger('collect:category:view', {
            categoryId: $('.category-heading').text()
        });
    }
    // category Track: End

    // Order Conversion Tracking: Start
    var $order;
    if ($('#order-details').length) {
        $order = $('#order-details').val();
    }
    if ($order) {
        $('body').trigger('collect:order:confirm', {
            order: JSON.parse($order)
        });
    }
    // Order Conversion Tracking: End
});

